import { entryStatus } from '@/db/schema/_types'
import { User, user } from '@/db/schema/user'
import { decimal, index, integer, jsonb, PgColumn, pgEnum, pgTable, serial, text, timestamp, unique } from 'drizzle-orm/pg-core'

export type CalculatedType = {
  ahvIvEoAnUngerundet: number
  ahvIvEoAn: number
  ahvIvEoAnFormel: string
  ahvIvEoAgUngerundet: number
  ahvIvEoAg: number
  ahvIvEoAgFormel: string
  alvAnUngerundet: number
  alvAn: number
  alvAnFormel: string
  alvAgUngerundet: number
  alvAg: number
  alvAgFormel: string
  alv2AnUngerundet?: number
  alv2An?: number
  alv2AnFormel?: string
  alv2AgUngerundet?: number
  alv2Ag?: number
  alv2AgFormel?: string
  nbuAnUngerundet: number
  nbuAn: number
  nbuAnFormel: string
  ahvVerwaltungAgUngerundet: number
  ahvVerwaltungAg: number
  ahvVerwaltungAgFormel: string
  buAgUngerundet: number
  buAg: number
  buAgFormel: string
  fakAgUngerundet: number
  fakAg: number
  fakAgFormel: string
  ktgAnUngerundet: number
  ktgAn: number
  ktgAgUngerundet: number
  ktgAg: number
  totalAbzuegeAnUngerundet: number
  totalAbzuegeAn: number
  totalAbzuegeAgUngerundet: number
  totalAbzuegeAg: number
  nettoUngerundet: number
  netto: number
  auszahlbarUngerundet: number
  auszahlbar: number
}
export const ktgType = pgEnum('ktg_type', ['men30', 'men60', 'women30', 'women60'])

export const salaryType = pgEnum('salary_type', [
  'salary_gross', // Bruttolohn
  'salary_net', // Nettolohn
  'salary_social_insurance_employer_part', // Sozialversicherung Arbeitgeberanteil
  'salary_total_deductions_employer_part', // Total Abzüge Arbeitgeberanteil
  'salary_total_deductions_employee_part', // Total Abzüge Arbeitnehmeranteil
  'salary_ktg', // Krankentaggeld
  'salary_gross_bonus', // Bruttolohn Bonus
  'salary_net_bonus', // Nettolohn Bonus
])

export const salary = pgTable(
  'salary',
  {
    id: serial('id').primaryKey(),
    migrationId: text('migration_id'), // Migration ID
    created: timestamp().defaultNow().notNull(),
    updated: timestamp().defaultNow().notNull(),
    issued: timestamp().defaultNow().notNull(),
    createdBy: integer('created_by')
      .notNull()
      .references((): PgColumn => user.id)
      .notNull(),
    gross: decimal('gross').notNull().default('0'),
    bvgAn: decimal('bvg_an').notNull().default('0'), // berufliche Vorsorge, Pensionskasse, 3te säule, an = arbeitnehmer
    bvgAg: decimal('bvg_ag').notNull().default('0'), // berufliche Vorsorge, Pensionskasse, 3te säule, ag = arbeitgeber
    ktgType: ktgType('ktg_type').notNull(), // krankentaggeld
    kinderzulagen: decimal().notNull().default('0'),
    calculated: jsonb().$type<CalculatedType>().notNull(),
    yearMonth: text('year_month').notNull(),
    status: entryStatus().notNull(),
    receiver: integer('receiver')
      .references((): PgColumn => user.id)
      .notNull(),
  },
  (t) => ({
    yearMonthIdx: index('salary_year_month_idx').on(t.yearMonth),
    yearMonthUniqueIdx: unique('salary_year_month_unique_idx').on(t.yearMonth, t.receiver),
  })
)

export type Salary = typeof salary.$inferSelect
export type SalaryResolved = { salary: Salary; user: User }
export type SalaryCalculated = Pick<
  Salary,
  'gross' | 'bvgAn' | 'bvgAg' | 'ktgType' | 'kinderzulagen' | 'receiver' | 'calculated' | 'yearMonth' | 'createdBy'
>
export type InsertSalary = typeof salary.$inferInsert
export type UpdateSalary = Partial<Salary>
